import { TableHead, TableRow, TableCell } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { CSSProperties, ReactElement } from 'react'
import { I18n } from 'src/i18n'
import { defaultTheme } from 'src/theme'
import styled from 'styled-components'

export interface Column {
  name: string
  style?: CSSProperties
}

interface Props {
  columns: Column[]
}

const Header = observer((props: Props): ReactElement => {
  const { columns } = props
  return (
    <>
      <colgroup>
        {columns.map(({ style }, index) => (
          <col key={`column_width_${index}`} style={style} />
        ))}
      </colgroup>
      <TableHead>
        <HeaderRow>
          {columns.map((column, index) => (
            <HeaderCell key={`review_part_header_${column.name}_${index}`}>
              {column.name && <I18n name={column.name} />}
            </HeaderCell>
          ))}
        </HeaderRow>
      </TableHead>
    </>
  )
})

const HeaderRow = styled(TableRow)`
  background: ${defaultTheme.colors.rowFeaturedBackground};
  box-shadow:
    inset 0px -1px 0px ${defaultTheme.colors.borderTable},
    inset 0px 1px 0px ${defaultTheme.colors.borderTable};
  height: 40px;
  margin-top: 16px;
`

const HeaderCell = styled(TableCell)`
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: ${defaultTheme.colors.columnBorder};
  border-bottom: none;
`

export default Header
